import { Component, OnInit } from '@angular/core';
import { Observable, tap } from 'rxjs';

import { QueryStringTypesEnum } from 'src/app/configs/query-string-types';
import {
  OccasionScheduledMessagesService,
  OutBoxMessagesService,
} from 'src/app/core/api/services';
import {
  CustomResultOfGetOccasionScheduledMessageByIdDto,
  CustomResultOfPaginatedListOfGetOccasionScheduledMessagesWithPaginationDto,
  GetOccasionScheduledMessageByIdPhonebookDto,
  GetOccasionScheduledMessagesWithPaginationDto,
  PaginatedListOfGetOccasionScheduledMessagesWithPaginationDto,
} from '../../../core/api/models';
import { BaseIndexPageComponent } from '../../shared/base/components/base-index-page.component';
import { FormPageConfig } from './../../../core/models/form-page-config.model';

@Component({
    selector: 'app-occasion-scheduled-messages',
    templateUrl: './occasion-scheduled-messages.component.html',
    standalone: false
})
export class OccasionScheduledMessageComponent
  extends BaseIndexPageComponent
  implements OnInit
{
  //#region Properties

  pageName = 'occasionScheduledMessage';
  modelWithPagination$: Observable<PaginatedListOfGetOccasionScheduledMessagesWithPaginationDto>;
  items$: Observable<Array<GetOccasionScheduledMessagesWithPaginationDto>>;
  formPageConfig: FormPageConfig<any> = {};
  isShowDetailPage: boolean = false;
  detailModel: GetOccasionScheduledMessagesWithPaginationDto;
  selectedPhonebooks: GetOccasionScheduledMessageByIdPhonebookDto[] = [];

  //#endregion

  constructor(
    protected currentService: OccasionScheduledMessagesService,
    public outBoxMessagesService: OutBoxMessagesService
  ) {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
    this.pageConfig.showAddBtn = false;
  }

  setPageAfterEnterUrl() {
    super.setPageAfterEnterUrl();
    let params = this.routingState.parseQueryString();
    for (const [key, value] of Object.entries(params)) {
      switch (key) {
        case QueryStringTypesEnum.Details_key:
          this.onDetail(value, false);
          break;
        case QueryStringTypesEnum.Update_key:
          this.onUpdate(value, false);
          break;
      }
    }
  }

  configTableColumns() {
    this.tableColumns = [
      {
        title: this.localizer.id,
        name: 'id',
        type: 'number',
        noNumberSeparator: true,
        hasSearch: true,
      },
      {
        title: this.localizer.organizationName,
        name: 'organizationName',
        hasSearch: true,
      },
      {
        title: `${this.tableVocabs}phonebookCustomFieldNameEn`,
        name: 'phonebookCustomFieldNameEn',
        hasSearch: true,
      },
      {
        title: `${this.tableVocabs}calenderEvent`,
        name: 'calenderEventTitle',
        hasSearch: true,
      },
      {
        title: `${this.tableVocabs}calenderOrganizationEvent`,
        name: 'calenderOrganizationEventTitle',
        hasSearch: true,
      },
      {
        title: `${this.tableVocabs}dynamicTemplateTitle`,
        name: 'dynamicTemplateTitle',
        hasSearch: true,
      },
      {
        title: 'common.privateNumber',
        name: 'privateNumber',
        hasSearch: true,
      },
      {
        title: this.localizer.active,
        name: 'isActive',
        type: 'boolean',
        hasSearch: true,
      },
      {
        title: `${this.tableVocabs}howManyDaysSendItBeforeDueDate`,
        name: 'howManyDaysSendItBeforeDueDate',
        hasSearch: true,
        type: 'number',
      },
      {
        title: 'common.sendHour',
        name: 'sendDateTime',
        hasSearch: true,
      },
      {
        title: this.localizer.createDate,
        name: 'created',
        hasSearch: true,
        type: 'dateTime',
      },
    ];
  }

  //#region Api

  //Get All
  getPaginationApi(): Observable<CustomResultOfPaginatedListOfGetOccasionScheduledMessagesWithPaginationDto> {
    return this.currentService.occasionScheduledMessagesGetOccasionScheduledMessagesWithPagination(
      {
        body: this.getBaseModelWithPaginationParams(),
      }
    );
  }

  //Get ById
  baseGetByIdApi(id: number): void {
    this.unSubs();

    this.pageConfig.loading = true;

    this.formPageConfig.editId = id;

    this.currentService
      .occasionScheduledMessagesUpdateGet({ Id: id })
      .pipe(
        tap((res: CustomResultOfGetOccasionScheduledMessageByIdDto) => {
          this.selectedPhonebooks = res?.data
            ?.phonebooks as GetOccasionScheduledMessageByIdPhonebookDto[];
        })
      )
      .pipe(this.basePipeOperators())
      .subscribe(this.baseGetByIdObserver);
  }

  //Delete
  baseDeleteApi(id: number) {
    this.unSubs();

    this.pageConfig.loading = true;
    this.lastSelectedItemId = id;
    this.currentService
      .occasionScheduledMessagesDelete({ body: { id: id } })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseDeleteObserver);
  }

  //#endregion

  onDetail(id, setUrl = true) {
    this.showParent = false;
    this.setParentQueryString();
    if (setUrl) {
      this.location.go(
        window.location.pathname +
          '?' +
          QueryStringTypesEnum.Details_key +
          '=' +
          id
      );
    }
    this.isShowDetailPage = true;

    this.currentService
      .occasionScheduledMessagesUpdateGet({ Id: id })
      .pipe(this.basePipeOperators())
      .subscribe((res) => (this.detailModel = res.data));
  }
}
